import { api } from "../utils/axios";

export const inviteStaff = async (
    restaurantId: string,
    email: string,
    role: string,
    token: string,
) => {
    try {
        const response = await api.post(`/api/restaurants/private/${restaurantId}/staff/invite`, 
            { email: email.trim(), role: role },
            {
                withCredentials: true,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error: any) {
        throw new Error(
            error.response?.data?.message ||
                error.response?.data?.error ||
                "Failed to invite staff."
        );
    }
};

export const removeStaff = async (
    restaurantId: string,
    staffId: string,
    token: string
) => {
    try {
        const response = await api.delete(`/api/restaurants/private/${restaurantId}/staff/${staffId}`, {
            withCredentials: true,
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error: any) {
        throw new Error(
            error.response?.data?.message ||
                error.response?.data?.error ||
                "Failed to remove staff."
        );
    }
};

export const changeStaffRole = async (
    restaurantId: string,
    staffId: string,
    newRole: string,
    token: string
) => {
  try {
    const response = await api.patch(`/api/restaurants/private/${restaurantId}/staff/${staffId}/role`,
      { role: newRole },
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to change staff role."
    );
  }
	};

export const acceptStaffInvitation = async (token: string) => {
  try {
    const response = await api.post(
      "/api/restaurants/private/staff/invitations/accept",
      { token },
      { withCredentials: true }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to accept invitation."
    );
  }
};
